export interface Comic {
  id: number;
  title: string;
  slug: string;
  cover: string;
  author: string;
  category: string;
  categorySlug: string;
  status: '连载中' | '已完结';
  rating: number;
  description: string;
  updateDate: string;
  views: number;
  chapters: Chapter[];
  tags: string[];
}

export interface Chapter {
  id: number;
  title: string;
  updateDate: string;
}

export interface Category {
  name: string;
  slug: string;
  icon: string;
  count: number;
}

export const categories: Category[] = [
  { name: '全部', slug: 'all', icon: 'ri-apps-line', count: 120 },
  { name: '恋爱', slug: 'romance', icon: 'ri-heart-line', count: 35 },
  { name: '奇幻', slug: 'fantasy', icon: 'ri-magic-line', count: 28 },
  { name: '动作', slug: 'action', icon: 'ri-fire-line', count: 22 },
  { name: '搞笑', slug: 'comedy', icon: 'ri-emotion-laugh-line', count: 15 },
  { name: '悬疑', slug: 'thriller', icon: 'ri-search-eye-line', count: 12 },
  { name: 'BL', slug: 'bl', icon: 'ri-user-heart-line', count: 18 },
  { name: '剧情', slug: 'drama', icon: 'ri-film-line', count: 20 },
];

export const comics: Comic[] = [
  {
    id: 1,
    title: '恶女的审判',
    slug: 'evil-woman-trial',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20female%20lead%20with%20elegant%20dark%20dress%20and%20mysterious%20expression%2C%20royal%20court%20background%2C%20dramatic%20lighting%2C%20romance%20fantasy%20genre%2C%20soft%20painterly%20illustration%20with%20warm%20golden%20accents&width=400&height=560&seq=comic-01&orientation=portrait',
    author: '金秀雅',
    category: '恋爱',
    categorySlug: 'romance',
    status: '连载中',
    rating: 9.5,
    description: '身为帝国最令人畏惧的公爵千金，艾琳娜被所有人称为"恶女"。然而在一场阴谋中失去一切后，她获得了重来一次的机会。这一次，她决定揭开真相，让真正的幕后黑手付出代价。但当冷酷的大公向她伸出援手时，复仇之路开始出现了意想不到的转折……',
    updateDate: '2026-08-04',
    views: 182500,
    tags: ['宫廷', '重生', '复仇', '甜宠'],
    chapters: [
      { id: 1, title: '第1话 恶女的诞生', updateDate: '2026-01-15' },
      { id: 2, title: '第2话 命运的转折', updateDate: '2026-01-22' },
      { id: 3, title: '第3话 大公的邀请', updateDate: '2026-01-29' },
      { id: 56, title: '第56话 真相浮现', updateDate: '2026-08-04' },
    ],
  },
  {
    id: 2,
    title: '剑与魔法纪元',
    slug: 'sword-magic-era',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20fantasy%20male%20warrior%20holding%20glowing%20sword%20with%20magical%20effects%2C%20epic%20battlefield%20background%2C%20dramatic%20composition%2C%20action%20fantasy%20genre%2C%20dynamic%20illustration%20with%20cool%20blue%20and%20silver%20tones&width=400&height=560&seq=comic-02&orientation=portrait',
    author: '李东旭',
    category: '奇幻',
    categorySlug: 'fantasy',
    status: '连载中',
    rating: 9.3,
    description: '在一个剑与魔法共存的世界里，平凡的少年卡因意外觉醒了传说级的天赋。从此，他踏上了成为最强剑士的征程。古老遗迹的秘密、帝国间的权力斗争、以及沉睡千年的黑暗力量——这一切都将在他的剑下揭开序幕！',
    updateDate: '2026-08-03',
    views: 156800,
    tags: ['冒险', '战斗', '成长', '魔法'],
    chapters: [
      { id: 1, title: '第1话 觉醒之日', updateDate: '2026-02-01' },
      { id: 2, title: '第2话 试炼开始', updateDate: '2026-02-08' },
      { id: 42, title: '第42话 龙之遗迹', updateDate: '2026-08-03' },
    ],
  },
  {
    id: 3,
    title: '甜蜜陷阱',
    slug: 'sweet-trap',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20romance%20couple%20in%20modern%20office%20setting%2C%20flirty%20atmosphere%2C%20handsome%20CEO%20and%20beautiful%20employee%2C%20sweet%20romantic%20comedy%20style%2C%20soft%20pastel%20colors%20with%20warm%20lighting&width=400&height=560&seq=comic-03&orientation=portrait',
    author: '崔智恩',
    category: '恋爱',
    categorySlug: 'romance',
    status: '已完结',
    rating: 9.6,
    description: '为了还清父亲的债务，韩素熙不得不在全国最大的企业集团工作。没想到第一天上班就遇到了那个男人——传闻中冷酷无情的CEO车敏俊。当他提出一份"特殊合约"时，素熙的生活彻底改变。这是一场甜蜜的陷阱，还是命中注定的爱情？',
    updateDate: '2026-07-28',
    views: 245000,
    tags: ['职场', '契约恋爱', '总裁', '甜宠'],
    chapters: [
      { id: 1, title: '第1话 第一天上班', updateDate: '2025-06-01' },
      { id: 2, title: '第2话 特殊合约', updateDate: '2025-06-08' },
      { id: 80, title: '第80话 最终章 永恒', updateDate: '2026-07-28' },
    ],
  },
  {
    id: 4,
    title: '暗夜追踪者',
    slug: 'night-tracker',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20thriller%20noir%20detective%20in%20dark%20alley%20at%20night%2C%20mysterious%20atmosphere%2C%20rainy%20city%20street%20with%20neon%20signs%2C%20suspense%20genre%2C%20cinematic%20lighting%20with%20cool%20blue%20and%20red%20contrast&width=400&height=560&seq=comic-04&orientation=portrait',
    author: '朴智浩',
    category: '悬疑',
    categorySlug: 'thriller',
    status: '连载中',
    rating: 9.1,
    description: '首尔的深夜，连环案件频发。前刑警姜宇振因一次失败的行动而离开警队，成为私家侦探。当一个看似普通的失踪案找上门来，他发现自己被卷入了一场横跨整个城市的地下阴谋。真相，往往隐藏在黑暗之中……',
    updateDate: '2026-08-04',
    views: 98400,
    tags: ['悬疑', '探案', '都市', '犯罪'],
    chapters: [
      { id: 1, title: '第1话 离职', updateDate: '2026-03-10' },
      { id: 2, title: '第2话 失踪者', updateDate: '2026-03-17' },
      { id: 34, title: '第34话 地下之王', updateDate: '2026-08-04' },
    ],
  },
  {
    id: 5,
    title: '武林高手在校园',
    slug: 'martial-hero-campus',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20action%20comedy%20high%20school%20student%20with%20martial%20arts%20pose%2C%20school%20campus%20background%2C%20energetic%20youthful%20style%2C%20dynamic%20action%20composition%2C%20vibrant%20colors&width=400&height=560&seq=comic-05&orientation=portrait',
    author: '郑泰浩',
    category: '动作',
    categorySlug: 'action',
    status: '连载中',
    rating: 9.0,
    description: '武林至尊林天在一次大战后穿越到现代，附身在一个被霸凌的高中生身上。在这个全新的世界里，他用绝世武功教训校园恶霸、参加体育比赛，甚至意外成为校园网红。但武林世界的追杀似乎也跟着他来到了现代……',
    updateDate: '2026-08-02',
    views: 132000,
    tags: ['穿越', '校园', '武功', '搞笑'],
    chapters: [
      { id: 1, title: '第1话 穿越', updateDate: '2026-04-05' },
      { id: 2, title: '第2话 新世界', updateDate: '2026-04-12' },
      { id: 28, title: '第28话 校际联赛', updateDate: '2026-08-02' },
    ],
  },
  {
    id: 6,
    title: '星空下的约定',
    slug: 'promise-under-stars',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20BL%20romance%20two%20young%20men%20under%20starry%20night%20sky%2C%20emotional%20and%20tender%20atmosphere%2C%20beautiful%20sentimental%20illustration%2C%20soft%20blue%20and%20purple%20night%20tones&width=400&height=560&seq=comic-06&orientation=portrait',
    author: '尹秀贤',
    category: 'BL',
    categorySlug: 'bl',
    status: '已完结',
    rating: 9.4,
    description: '高中时期，天文社的韩星和柳河是最亲密的伙伴。但毕业前夕的一场误会让他们分道扬镳。七年后，成为天文学家的韩星在一次学术会议上与已成为作家的柳河重逢。星空依旧，那份未曾说出口的情感是否还能继续？',
    updateDate: '2026-07-15',
    views: 189000,
    tags: ['重逢', '校园', '治愈', '慢热'],
    chapters: [
      { id: 1, title: '第1话 天文社', updateDate: '2025-10-01' },
      { id: 2, title: '第2话 最好的朋友', updateDate: '2025-10-08' },
      { id: 60, title: '第60话 星空下的约定·终', updateDate: '2026-07-15' },
    ],
  },
  {
    id: 7,
    title: '爆笑便利店',
    slug: 'funny-convenience-store',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20comedy%20slice%20of%20life%20convenience%20store%20setting%2C%20funny%20characters%20with%20exaggerated%20expressions%2C%20colorful%20and%20lively%20style%2C%20warm%20everyday%20comedy%20atmosphere&width=400&height=560&seq=comic-07&orientation=portrait',
    author: '安世英',
    category: '搞笑',
    categorySlug: 'comedy',
    status: '连载中',
    rating: 9.2,
    description: '一间普通的24小时便利店里，聚集了一群不普通的打工仔。有梦想成为歌手的夜班收银员、偷偷写小说的店长、还有总是惹麻烦的兼职大学生。在这小小的空间里，每一天都在上演令人捧腹大笑的故事！',
    updateDate: '2026-08-05',
    views: 110500,
    tags: ['日常', '搞笑', '职场', '群像'],
    chapters: [
      { id: 1, title: '第1话 第一天上班', updateDate: '2026-05-01' },
      { id: 2, title: '第2话 奇葩顾客', updateDate: '2026-05-08' },
      { id: 20, title: '第20话 店长的秘密', updateDate: '2026-08-05' },
    ],
  },
  {
    id: 8,
    title: '帝国之影',
    slug: 'empire-shadow',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20historical%20drama%20royal%20palace%20intrigue%2C%20elegant%20noble%20characters%20in%20traditional%20Korean%20inspired%20costumes%2C%20political%20drama%20atmosphere%2C%20rich%20golden%20and%20crimson%20color%20palette&width=400&height=560&seq=comic-08&orientation=portrait',
    author: '韩敏珠',
    category: '剧情',
    categorySlug: 'drama',
    status: '连载中',
    rating: 9.7,
    description: '帝国宫廷暗流涌动。年幼的皇子李玄在母后被废后，被流放至边境。十五年后，他以一介平民的身份重返帝都，却发现自己的真实身份远比想象中复杂。皇位之争、家族仇恨、以及被掩埋的历史真相——帝国的影子下，一切才刚刚开始。',
    updateDate: '2026-08-04',
    views: 201000,
    tags: ['宫廷', '权力斗争', '复仇', '历史'],
    chapters: [
      { id: 1, title: '第1话 流放', updateDate: '2026-01-10' },
      { id: 2, title: '第2话 边境少年', updateDate: '2026-01-17' },
      { id: 48, title: '第48话 血染王座', updateDate: '2026-08-04' },
    ],
  },
];

export const faqs = [
  {
    question: '韩漫之家是什么？',
    answer: '韩漫之家是一个专注于韩国漫画的免费在线阅读平台，收录了恋爱、奇幻、动作、搞笑等多种类型的优质韩漫资源。我们致力于为广大漫画爱好者提供流畅便捷的阅读体验。',
  },
  {
    question: '如何找到想看的韩漫？',
    answer: '您可以通过首页的分类导航进入不同类型浏览，也可以通过搜索功能输入漫画名称快速找到目标作品。我们的分类系统涵盖恋爱、奇幻、动作、搞笑、悬疑、BL、剧情等多个类别。',
  },
  {
    question: '韩漫之家是免费的吗？',
    answer: '是的，韩漫之家目前对所有用户完全免费开放。我们希望通过免费模式让更多读者能够接触到优质的韩国漫画作品。',
  },
  {
    question: '多久更新一次内容？',
    answer: '我们每天都会更新全站漫画资源。热门连载作品通常每周更新，具体更新频率因作品而异。您可以在每部漫画的详情页查看最新的更新日期。',
  },
  {
    question: '可以在手机上阅读吗？',
    answer: '当然可以！韩漫之家完全适配手机、平板和电脑等多种设备，您可以在任何设备上享受流畅的阅读体验。',
  },
  {
    question: '如何获取更新通知？',
    answer: '您可以通过订阅我们的邮件通知来获取最新更新信息。在首页的订阅区域输入您的邮箱地址即可。',
  },
];

export const testimonials = [
  {
    name: '小雨',
    avatar: 'https://readdy.ai/api/search-image?query=Cute%20anime%20style%20young%20girl%20avatar%20portrait%2C%20soft%20pink%20background%2C%20simple%20and%20clean%20illustration&width=80&height=80&seq=avatar-01&orientation=squarish',
    comment: '韩漫之家的资源真的太全了！找了好久的一部老韩漫居然在这里找到了，而且更新速度超快，简直是宝藏网站！',
    rating: 5,
  },
  {
    name: '漫画迷小王',
    avatar: 'https://readdy.ai/api/search-image?query=Simple%20anime%20style%20young%20boy%20avatar%20portrait%2C%20blue%20background%2C%20clean%20minimal%20illustration&width=80&height=80&seq=avatar-02&orientation=squarish',
    comment: '分类很清晰，找漫画特别方便。页面设计也很简洁干净，阅读体验比很多同类网站好太多了。',
    rating: 5,
  },
  {
    name: '星空漫读',
    avatar: 'https://readdy.ai/api/search-image?query=Anime%20style%20young%20woman%20avatar%20portrait%2C%20purple%20background%2C%20elegant%20simple%20illustration&width=80&height=80&seq=avatar-03&orientation=squarish',
    comment: '从朋友那里知道这个网站的，一用就爱上了。界面美观，漫画质量高，已经推荐给了好多朋友！',
    rating: 4,
  },
  {
    name: '追漫达人',
    avatar: 'https://readdy.ai/api/search-image?query=Anime%20style%20cool%20teenager%20avatar%20portrait%2C%20orange%20background%2C%20modern%20clean%20illustration&width=80&height=80&seq=avatar-04&orientation=squarish',
    comment: '每天必刷的网站！更新提醒很及时，再也不用担心错过喜欢的漫画更新了。真心推荐给所有喜欢韩漫的朋友。',
    rating: 5,
  },
];

export const siteInfo = {
  name: '韩漫之家',
  tagline: '免费韩漫大全 - 韩漫在线阅读',
  description: '韩漫之家作为快捷通道，通过简单网址即可访问免费韩漫大全并进行韩漫在线阅读，极大简化您的找书流程。汇聚海量优质韩国漫画，涵盖恋爱、奇幻、动作、搞笑等多种类型，为您提供流畅便捷的阅读体验。',
  email: 'contact@hanmanzhijia.com',
  established: '2023',
  comicCount: '1000+',
  dailyVisitors: '50000+',
  totalViews: '10000000+',
};